import $ from 'jquery';
import { hideAllMenus } from '~core/hideAllMenus';

export const showMenuMagicFrame = () => {
  hideAllMenus();
  $('#editor-menu-images').show();
  $('[data-feature="magic-frame"]').show();
  $('#editor-menu-object').show();
};
